import { render, staticRenderFns } from "./GLIcon.vue?vue&type=template&id=70da1a81&scoped=true"
import script from "./GLIcon.vue?vue&type=script&lang=js"
export * from "./GLIcon.vue?vue&type=script&lang=js"
import style0 from "./GLIcon.vue?vue&type=style&index=0&id=70da1a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da1a81",
  null
  
)

export default component.exports